import { render, staticRenderFns } from "./EmptyIcon.vue?vue&type=template&id=0b49191a&scoped=true&"
import script from "./EmptyIcon.vue?vue&type=script&lang=js&"
export * from "./EmptyIcon.vue?vue&type=script&lang=js&"
import style0 from "./EmptyIcon.vue?vue&type=style&index=0&id=0b49191a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b49191a",
  null
  
)

export default component.exports